import Request from '../../../../src/core/gd/data/request'
import {ApiSystemStatus} from "../manager/universal-task-selector/@types";

export default class ApiTag {

    static universalTaskRequestV2(tagId:ID, systemStatus:ApiSystemStatus | null, fields:any) {
        // GET http://{{api-app}}/tag/Be3MhR/tasks-new?cid=U48GJt&systemStatus=all&tags&timeReports&taskUsers&projectDeadlines&predecessors&successors

        const params = {
            systemStatus: systemStatus,
        }

        // @ts-ignore
        _.map(fields, field => params[field] = true)

        return new Request(this,'GET','tag/{0}/tasks'.f(tagId), params);
    }

    // deprecated
    universalTaskRequest(tagId:ID, systemStatus:ApiSystemStatus | null, fields:any) {
        // GET http://{{api-app}}/tag/Be3MhR/tasks-new?cid=U48GJt&systemStatus=all&tags&timeReports&taskUsers&projectDeadlines&predecessors&successors

        const params = {
            systemStatus: systemStatus,
        }

        // @ts-ignore
        _.map(fields, field => params[field] = true)

        return new Request(this,'GET','tag/{0}/tasks'.f(tagId), params);
    }
}